import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;
  .other-reason {
    font-weight: bold;
    margin-top: 5px;
  }
`;
